var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ma-accordion",
    {
      ref: "accordion",
      staticClass: "piece",
      attrs: {
        expanded: _vm.expanded,
        confirmed: _vm.damagedPiece.confirmedMultidamage,
      },
      on: {
        deletePiece: function ($event) {
          return _vm.$emit("deletePiece")
        },
      },
    },
    [
      _c("template", { slot: "accordionTop" }, [
        _c("p", { staticClass: "piece-title" }, [
          _vm._v(_vm._s(_vm.pieceTitle)),
        ]),
      ]),
      _c(
        "template",
        { slot: "accordionBottom" },
        [
          !_vm.photosTaken
            ? _c(
                "div",
                {
                  staticClass:
                    "container-input flowName === 'damage_billma_agent_new' || flowName === 'e2e_new' ? input-meters : ''",
                },
                [
                  _c("ma-input-surface", {
                    staticClass: "input-surface",
                    attrs: {
                      type: "number",
                      name: "surfaceInput",
                      col: "4",
                      literal: _vm.$t("multidamageList.inputTitle"),
                      placeholder: _vm.$t("multidamageList.inputHint"),
                      inputError: _vm.$v.inputSurfaceValue.$error,
                      inputmode: "numeric",
                    },
                    on: {
                      change: _vm.handleOnChangeSurfaceInput,
                      input: _vm.handleOnChangeSurfaceInput,
                    },
                    model: {
                      value: _vm.$v.inputSurfaceValue.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.inputSurfaceValue,
                          "$model",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "$v.inputSurfaceValue.$model",
                    },
                  }),
                  !_vm.$v.inputSurfaceValue.$error &&
                  _vm.flowName !== "damage_billma_agent_new" &&
                  _vm.flowName !== "e2e_new"
                    ? _c(
                        "div",
                        { staticClass: "content-info" },
                        [
                          _c("svgicon", {
                            attrs: {
                              name: "ico-info",
                              color: "#A7AEB6",
                              width: "12",
                              height: "12",
                            },
                          }),
                          _c("p", { staticClass: "info-text grey" }, [
                            _vm._v(_vm._s(_vm.$t("multidamageList.inputHint"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.flowName === "damage_billma_agent_new" ||
          _vm.flowName === "e2e_new"
            ? _c("div", { staticClass: "content-material mg mg--t-2 right" }, [
                _c(
                  "p",
                  {
                    staticClass: "text-small",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("openSurfaceModal")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "blueDark mg mg--r-1 mg--t-2" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("multidamageList.calculateSurfaceLink.link")
                        )
                      ),
                    ]),
                    _c("svgicon", {
                      attrs: {
                        name: "question",
                        color: "#005BA5",
                        width: "12",
                        height: "12",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "content-material-camera" },
            _vm._l(_vm.damagedPiece.damagedParts, function (damagedPart) {
              return _vm.surfaceInputIsValid &&
                _vm.isPhotoclaimFlow &&
                _vm.flowName === "photoclaim"
                ? _c("ma-damaged-part-camera", {
                    key: damagedPart.key,
                    attrs: {
                      damagedPart: damagedPart,
                      buttonEnable: _vm.surfaceInputIsValid,
                      photosTaken: _vm.photosTaken,
                    },
                    on: {
                      deleteDamagedPart: function ($event) {
                        return _vm.$emit("deleteDamagedPart", damagedPart.key)
                      },
                      openModalCamera: function ($event) {
                        return _vm.$emit("openModalCamera", $event)
                      },
                      openCameraForm: function ($event) {
                        return _vm.$emit("openCameraForm", $event)
                      },
                      deleteDamage: function ($event) {
                        return _vm.$emit("deleteDamage", {
                          partKey: damagedPart.key,
                          damageIndex: $event,
                        })
                      },
                      editDamage: function ($event) {
                        return _vm.$emit("editDamage", {
                          partKey: damagedPart.key,
                          damageIndex: $event,
                        })
                      },
                    },
                  })
                : _vm._e()
            }),
            1
          ),
          _vm._l(_vm.damagedPiece.damagedParts, function (damagedPart) {
            return !_vm.isPhotoclaimFlow &&
              _vm.flowName !== "damage_billma_agent_new" &&
              _vm.flowName !== "e2e_new"
              ? _c(
                  "div",
                  { key: damagedPart.key, staticClass: "content-material" },
                  [
                    _vm.surfaceInputIsValid || _vm.hasDamages
                      ? _c("ma-damaged-part", {
                          attrs: {
                            damagedPart: damagedPart,
                            buttonEnable: _vm.surfaceInputIsValid,
                          },
                          on: {
                            deleteDamagedPart: function ($event) {
                              return _vm.$emit(
                                "deleteDamagedPart",
                                damagedPart.key
                              )
                            },
                            openModal: function ($event) {
                              return _vm.$emit("openModal", $event)
                            },
                            deleteDamage: function ($event) {
                              return _vm.$emit("deleteDamage", {
                                partKey: damagedPart.key,
                                damageIndex: $event,
                              })
                            },
                            editDamage: function ($event) {
                              return _vm.$emit("editDamage", {
                                partKey: damagedPart.key,
                                damageIndex: $event,
                              })
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._l(_vm.damagedPiece.damagedParts, function (damagedPart) {
            return _vm.flowName === "damage_billma_agent_new" ||
              _vm.flowName === "e2e_new"
              ? _c(
                  "div",
                  {
                    key: damagedPart.key,
                    staticClass: "content-material-camera",
                  },
                  [
                    _c("ma-damaged-part-camera", {
                      attrs: {
                        damagedPart: damagedPart,
                        buttonEnable: _vm.surfaceInputIsValid,
                        photosTaken: _vm.photosTaken,
                      },
                      on: {
                        deleteDamagedPart: function ($event) {
                          return _vm.$emit("deleteDamagedPart", damagedPart.key)
                        },
                        openModalCamera: function ($event) {
                          return _vm.$emit("openModalCamera", $event)
                        },
                        openCameraForm: function ($event) {
                          return _vm.$emit("openCameraForm", $event)
                        },
                        deleteDamage: function ($event) {
                          return _vm.$emit("deleteDamage", {
                            partKey: damagedPart.key,
                            damageIndex: $event,
                          })
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm.flowName === "damage_billma_agent_new" ||
          (_vm.flowName === "e2e_new" && _vm.isMultidamageFlow) ||
          _vm.flowName === "photoclaim"
            ? _c(
                "div",
                { staticClass: "container-btn-overall mg mg--t-6" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn mainBlue btnBlue",
                      attrs: { disabled: _vm.isDisabledBtn },
                      on: { click: _vm.handleOpenModal },
                    },
                    [
                      _c("p", { staticClass: "text-medium" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("multidamageList.cameraFlow.continuerBtn")
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "ma-modal",
                    {
                      ref: "modalOverallImage",
                      staticClass: "modal-confirmation",
                      attrs: { type: "small", closeIsHidden: "" },
                    },
                    [
                      _c(
                        "template",
                        { staticClass: "modal__overall", slot: "modalContent" },
                        [
                          _c("div", { staticClass: "modal__main" }, [
                            _c(
                              "h4",
                              { staticClass: "gray headline-large mg mg--b-3" },
                              [_vm._v("Photo de la pièce")]
                            ),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "gray text-medium-large modal__paragraph mg mg--t-2",
                              },
                              [
                                _vm._v(
                                  " Nous avons besoin d’une vision globale de la pièce pour estimer la gravité des dommages, et envisager les travaux nécessaires."
                                ),
                              ]
                            ),
                            _c("br"),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "gray text-medium-large modal__paragraph",
                              },
                              [
                                _vm._v(
                                  " Reculez le plus loin possible des dommages et prenez une photo de toute la pièce."
                                ),
                              ]
                            ),
                            _c("br"),
                            _c(
                              "div",
                              { staticClass: "container-warning mg mg--t-1" },
                              [
                                _c("svgicon", {
                                  attrs: {
                                    name: "Info",
                                    color: "#005BA5",
                                    height: "32",
                                    width: "auto",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "container-warning__description",
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "blueLight text-small modal__paragraph",
                                      },
                                      [
                                        _vm._v(
                                          "Ces images seront utilisées pour évaluer vos dommages."
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "blueLight text-small modal__paragraph",
                                      },
                                      [
                                        _vm._v(
                                          "Elles ne seront pas utilisées à d'autres fins."
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "container-btn-add-element-camera mg mg--t-4",
                              },
                              [
                                !_vm.showModalButtons
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn",
                                        on: {
                                          click:
                                            _vm.handleOnShowModalOverallCamera,
                                        },
                                      },
                                      [
                                        _c("svgicon", {
                                          attrs: {
                                            name: "camera-create",
                                            color: "#005BA5",
                                            height: "15",
                                            width: "auto",
                                          },
                                        }),
                                        _c(
                                          "p",
                                          { staticClass: "text-medium" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "multidamageList.cameraFlow.cameraBtn"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                !_vm.showModalButtons
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn buttonLink",
                                        on: {
                                          click: _vm.handleNoRequiredPhoto,
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "text-medium black" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "multidamageList.cameraFlow.noRequired"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.showModalButtons
                                  ? _c(
                                      "div",
                                      { staticClass: "modal__buttons" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "camera__damages" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "damage__photos" },
                                              [
                                                _c(
                                                  "figure",
                                                  { staticClass: "damage-img" },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.overallPhoto,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn-overall mainBlue mg mg--t-2",
                                            on: { click: _vm.handleOverallImg },
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "text-medium" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "multidamageList.cameraFlow.continuerBtn"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "text-medium mg mg--t-4",
                                            on: {
                                              click:
                                                _vm.handleOnShowModalOverallCamera,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "blueDark" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "multidamageList.cameraFlow.againBtn"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          !_vm.surfaceInputIsValid &&
          !_vm.hasDamages &&
          _vm.flowName !== "damage_billma_agent_new" &&
          _vm.flowName !== "e2e_new"
            ? _c("div", { staticClass: "content-material mg mg--t-5 center" }, [
                _c("p", { staticClass: "text-large gray" }, [
                  _vm._v(
                    _vm._s(_vm.$t("multidamageList.calculateSurfaceLink.text1"))
                  ),
                ]),
                _c(
                  "p",
                  {
                    staticClass: "text-link mg mg--t-2",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("openSurfaceModal")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "blueDark" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("multidamageList.calculateSurfaceLink.link")
                        )
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }